<template>
    <table class="table">
        <tr>
            <th>
                <test-result-circle class="upload-requests-count-item" result="MTR_RES_PASSED"
                                    :count="1"/>
            </th>
            <td>Success upload requests</td>
            <th>
                <test-result-circle class="upload-requests-count-item" result="MTR_RES_INFO"
                                    :count="1"/>
            </th>
            <td>Upload requests without XML file</td>
            <th>
                <test-result-circle class="upload-requests-count-item" result="MTR_RES_FAILED"
                                    :count="1"/>
            </th>
            <td>Failed upload requests</td>
        </tr>
    </table>
</template>
<script>
import TestResultCircle from "./TestResultCircle"

export default {
    name: 'UploadRequestResultsAnnotation',
    components: {TestResultCircle},
}
</script>
<style lang="scss" scoped>
.upload-requests-count {
    color: $grey-light;
    min-width: 2rem;
    font-size: 0.75rem;
    margin-right: 0.5rem;
}
</style>